import { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { Box, TextField, Button } from "@mui/material";
import { SERVER_URL } from "../app/constant";

import { useToken } from "../auth/useToken";
import { useQueryParams } from "../hooks/useQueryParams";

export const LogInPage = () => {
  const [, setToken] = useToken();

  const [errorMessage, setErrorMessage] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [emailValue, setEmailValue] = useState("");
  const [passwordValue, setPasswordValue] = useState("");

  const history = useHistory();

  const handleCallbackResponse = async (response) => {
    setErrorMessage("");
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({"token": response.credential}),
    };

    try {
      const res = await fetch(`${SERVER_URL}/google-auth`, requestOptions);
      if (!res.ok) {
        throw new Error("Google sign-in failed. Please try again.");
      }
      const data = await res.json();
      setToken(data.token);
      history.push("/");
    } catch (e) {
      setErrorMessage(e.message);
    }
  }

  useEffect(() => {
    /* global google */
    google.accounts.id.initialize({
      client_id: "949161531967-g19rrq89h0eur9a7ni9nkvuk2sj069rc.apps.googleusercontent.com",
      callback: handleCallbackResponse
    });

    google.accounts.id.renderButton(
      document.getElementById("signInDiv"),
      { theme: "outline", size: "large", width: "300px", mt: 3 }
    );
  }, []);

  const onLogInClicked = async () => {
    setIsSubmitting(true);
    setErrorMessage("");
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        email: emailValue,
        password: passwordValue,
      }),
    };

    try {
      const response = await fetch(`${SERVER_URL}/login`, requestOptions);
      if (!response.ok) {
        throw new Error("Incorrect email or password.");
      }
      const data = await response.json();
      setToken(data.token);
      history.push("/");
    } catch (e) {
      setErrorMessage(e.message);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Box
      component="main"
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <h1 style={{ color: "#3366BB", marginTop: "24px" }}>Log In</h1>
      {errorMessage && <div className="fail" role="alert">{errorMessage}</div>}
      <TextField
        sx={{ width: "300px", mt: 2 }}
        id="login-email"
        label="Email"
        type="email"
        autoComplete="email"
        value={emailValue}
        onChange={(e) => setEmailValue(e.target.value)}
      />
      <TextField
        sx={{ width: "300px", mt: 2 }}
        id="login-password"
        label="Password"
        type="password"
        value={passwordValue}
        onChange={(e) => setPasswordValue(e.target.value)}
      />
      <Button
        variant="contained"
        sx={{ width: "300px", mt: 2 }}
        disabled={!emailValue || !passwordValue || isSubmitting}
        onClick={onLogInClicked}
      >
        {isSubmitting ? "Logging in..." : "Log In"}
      </Button>
      <p style={{ color: "#3366BB" }}>OR</p>
      {<div id="signInDiv"></div>}
      <Button sx={{ mt: 2 }} onClick={() => history.push("/forgot-password")}>
        Forgot your password?
      </Button>
      <Button sx={{ mt: 2 }} onClick={() => history.push("/signup")}>
        Don't have an account? Sign Up
      </Button>
    </Box>
  );
};
